import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';
import type { components, paths } from './nettbank.api.models';

const runtimeFetch: typeof fetch = (input, init) => globalThis.fetch(input, init);

export const fetchClient = createFetchClient<paths>({ fetch: runtimeFetch });

fetchClient.use({
  onResponse: (response) => {
    // Configure to throw on HTTP error of type 400, as these do not fail the promise by default in native fetch
    // https://github.com/TanStack/query/discussions/1385
    if (response.response.status >= 400 && response.response.status < 500) {
      return Promise.reject(new Error(`HTTP was rejected: status: ${response.response.status}, statusText: ${response.response.statusText}`));
    }
  },
});

export const apiClient = createClient(fetchClient);

/**
 * Extracts a named OpenAPI component schema directly. Useful for shared DTOs that are not
 * tied to a single operation's response.
 * Generally not recommended unless necessary. For data props between shared components, prefer declaring specific properties for that component instead so it can more easily be shared and refactored without being tied to a specific API response.
 *
 * @example
 * type UserDto = ApiSchema<'UserDto'>;
 */
export type ApiSchema<T extends keyof components['schemas']> = components['schemas'][T];
